import { apiClient, ensureCsrfCookie } from '@/api/client'
import type { ApiSuccessResponse } from '@/types/api'

export interface RecruiterTeamMember {
  id: number
  name: string
  email: string
  phone: string | null
  userType: string
  accountStatus: string
  isPrimaryAdmin: boolean
  membershipStatus: 'active' | 'inactive' | 'pending' | null
  createdAt: string
}

async function withCsrf<T>(fn: () => Promise<T>): Promise<T> {
  await ensureCsrfCookie()
  return fn()
}

export const teamApi = {
  list: async () => {
    const { data } =
      await apiClient.get<ApiSuccessResponse<RecruiterTeamMember[]>>('/recruiter/team')
    return data.data
  },

  invite: (payload: { name: string; email: string; phone: string }) =>
    withCsrf(async () => {
      const { data } = await apiClient.post<ApiSuccessResponse<RecruiterTeamMember>>(
        '/recruiter/team',
        payload,
      )
      return data.data
    }),

  activate: (userId: number) =>
    withCsrf(async () => {
      const { data } = await apiClient.patch<ApiSuccessResponse<RecruiterTeamMember>>(
        `/recruiter/team/${userId}/activate`,
      )
      return data.data
    }),

  deactivate: (userId: number) =>
    withCsrf(async () => {
      const { data } = await apiClient.patch<ApiSuccessResponse<RecruiterTeamMember>>(
        `/recruiter/team/${userId}/deactivate`,
      )
      return data.data
    }),
}
